export const resources = {
  MessageServicePageNotFound: ''
};
